/* global axios */
import ApiClient from '../ApiClient';

class CaptainInboxes extends ApiClient {
  constructor() {
    super('captain/assistants', { accountScoped: true });
  }

  get({ assistantId } = {}) {
    return axios.get(`${this.url}/${assistantId}/inboxes`);
  }

  create(params = {}) {
    const { assistantId, inboxId } = params;
    return axios.post(`${this.url}/${assistantId}/inboxes`, {
      inbox: { inbox_id: inboxId },
    });
  }

  updateAppointments({ assistantId, inboxId, appointmentsEnabled } = {}) {
    return axios.patch(`${this.url}/${assistantId}/inboxes/${inboxId}`, {
      inbox: { appointments_enabled: appointmentsEnabled },
    });
  }

  updateAudience({ assistantId, inboxId, audienceMode, audienceRules }) {
    return axios.patch(`${this.url}/${assistantId}/inboxes/${inboxId}`, {
      inbox: { audience_mode: audienceMode, audience_rules: audienceRules },
    });
  }

  delete(params = {}) {
    const { assistantId, inboxId } = params;
    return axios.delete(`${this.url}/${assistantId}/inboxes/${inboxId}`);
  }
}

export default new CaptainInboxes();
